export const h = {
  navMenu: ["ホーム","予約特典", "ヒーロー情報", "ゲーム情報"],

   
  }


// WEBPACK FOOTER //
// ./src/i18n/lan/jp.js